import { Injectable } from "@angular/core";
import { LocalStorageService } from "./local-storage.service";
import {
  IRequestPwdRecovery,
  IResetPassword,
  IUserCredentials,
} from "../data-types/user.interface";
import { HttpClientService } from "./http-client.service";
import { EStorageType } from "../data-types/storage.enum";
import { IService } from "../data-types/services.interface";

@Injectable({
  providedIn: "root",
})
export class StateService {
  static instance: StateService = new StateService();
  constructor() {
    return (StateService.instance = StateService.instance || this);
  }

  public async getStates(int): Promise<any> {
    return new Promise((resolve, reject) => {
      let url: string = "states?type_id=" + int;
      let headers: any = {
        Authorization: `Bearer ${LocalStorageService.instance.get(
          EStorageType.Token
        )}`,
      };

      HttpClientService.instance
        .get(url, headers)
        .then((result: any) => {
          resolve(result);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public async getBookingStates(): Promise<any> {
    return new Promise((resolve, reject) => {
      let url: string = "bookings/states";
      let headers: any = {
        Authorization: `Bearer ${LocalStorageService.instance.get(
          EStorageType.Token
        )}`,
      };

      HttpClientService.instance
        .get(url, headers)
        .then((result: any) => {
          resolve(result);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
